import { useEffect, useState } from 'react';

import useLocalSettings from '@/stores/useLocalSettings';

export default function useTheme() {
  const theme = useLocalSettings((state) => state.darkMode);
  const [systemTheme, setSystemTheme] = useState<'dark' | 'light' | undefined>(
    undefined,
  );

  useEffect(() => {
    const root = document.documentElement;
    const systemTheme = matchMedia('(prefers-color-scheme: dark)');

    const updateTheme = () => {
      root.classList.remove('light', 'dark');

      if (theme === 'SYSTEM') {
        const darkOrLight = systemTheme.matches ? 'dark' : 'light';
        root.classList.add(darkOrLight);
        setSystemTheme(darkOrLight);

        return;
      }

      root.classList.add(theme.toLowerCase());
    };

    updateTheme();
    systemTheme.addEventListener('change', updateTheme);

    return () => {
      systemTheme.removeEventListener('change', updateTheme);
    };
  }, [theme]);

  return theme === 'SYSTEM'
    ? systemTheme === 'dark'
      ? 'DARK'
      : 'LIGHT'
    : theme;
}
